import './panel-byline.scss';

const PanelByline = ({ text }) => {
    return <span className="panel-byline">{text}</span>;
};

export default PanelByline;
